import React, { useRef, useEffect, useState } from 'react';
import { Eye, Pencil, Upload, Trash2, UploadIcon, Link } from 'lucide-react';
import './ActionMenu.css';

const ActionMenu = ({ onAction, document, buttonRef }) => {
  const menuRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const calculatePosition = () => {
      if (buttonRef?.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;
        const menuHeight = 200; // Approximate menu height

        if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
          setMenuStyle({
            bottom: '100%',
            top: 'auto',
            marginBottom: '4px',
            marginTop: '0'
          });
        } else {
          setMenuStyle({
            top: '100%',
            bottom: 'auto',
            marginTop: '4px',
            marginBottom: '0'
          });
        }
      }
    };

    // Calculate position after a small delay to ensure menu is rendered
    setTimeout(calculatePosition, 0);
    
    // Also recalculate on scroll or resize
    window.addEventListener('scroll', calculatePosition, true);
    window.addEventListener('resize', calculatePosition);
    
    return () => {
      window.removeEventListener('scroll', calculatePosition, true);
      window.removeEventListener('resize', calculatePosition);
    };
  }, [buttonRef]);

  const handleClick = (action, e) => {
    e.stopPropagation();
    onAction(action);
  };

  const isLocalPlatform = !document?.is_shopify_page && document?.source !== 'Shopify';

  return (
    <div ref={menuRef} className="action-menu" style={menuStyle}>
      <button 
        className="menu-item"
        onClick={(e) => handleClick('preview', e)}
      >
        <Eye size={16} />
        <span>Preview & Publish</span>
      </button>
      
      <button 
        className="menu-item"
        onClick={(e) => handleClick('edit', e)}
      >
        <Pencil size={16} />
        <span>Edit</span>
      </button>
    
      {/* Share button - only for local platform products */}
      {isLocalPlatform && document?.id && (
        <button 
          className="menu-item"
          onClick={(e) => handleClick('share', e)}
        >
          <Link size={16} />
          <span>Share</span>
        </button>
      )}
      
      {/* <button 
        className="menu-item"
        onClick={(e) => handleClick('publish', e)}
      >
        <Upload size={16} />
        <span>Publish</span>
      </button> */}
      
      <button 
        className="menu-item delete"
        onClick={(e) => handleClick('delete', e)}
      >
        <Trash2 size={16} />
        <span>Delete</span>
      </button>
    </div>
  );
};

export default ActionMenu;